module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "card"
  }, [_c('InnerLoading', {
    attrs: {
      "is-loading": _vm.isLoading
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "card-header"
  }, [_c('i', {
    staticClass: "fa fa-list"
  }), _vm._v("\n            " + _vm._s(_vm.title) + "\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "card-body"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-6 offset-2",
    class: {
      'dropdown-has-error': _vm.$v.select.id.$error
    }
  }, [_c('label', [_vm._v(_vm._s(_vm.title) + "*")]), _vm._v(" "), _c('select-api', {
    attrs: {
      "endpoint": _vm.urlSelect,
      "opt-text": _vm.optText
    },
    model: {
      value: (_vm.select.id),
      callback: function($$v) {
        _vm.$set(_vm.select, "id", $$v)
      },
      expression: "select.id"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-2"
  }, [_c('button', {
    staticClass: "btn btn-primary",
    staticStyle: {
      "margin-top": "30px"
    },
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.save
    }
  }, [_vm._v("Adicionar")])])]), _vm._v(" "), _c('div', {
    staticClass: "row mt-10",
    staticStyle: {
      "margin-top": "10px"
    }
  }, [_c('div', {
    staticClass: "col-md-8 offset-2"
  }, [_c('table', {
    staticClass: "table table-bordered table-striped table-md"
  }, [_c('thead', [(_vm.draggable == true) ? _c('th') : _vm._e(), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.title))]), _vm._v(" "), _c('th', [_vm._v("Ações")])]), _vm._v(" "), (_vm.draggable == true) ? _c('draggable', {
    attrs: {
      "element": 'tbody'
    },
    on: {
      "start": function($event) {
        _vm.drag = true
      },
      "end": function($event) {
        _vm.drag = false
      }
    },
    model: {
      value: (_vm.list),
      callback: function($$v) {
        _vm.list = $$v
      },
      expression: "list"
    }
  }, _vm._l((_vm.list), function(item) {
    return _c('tr', {
      key: item.id
    }, [_c('td', {
      staticStyle: {
        "width": "10px"
      }
    }, [_c('i', {
      staticClass: "fa fa-align-justify"
    })]), _vm._v(" "), _c('td', {
      attrs: {
        "data-label": _vm.title
      }
    }, [_vm._v(_vm._s(item[_vm.paramLabel] ? item[_vm.paramLabel] : item[_vm.paramName].nome))]), _vm._v(" "), _c('td', [_c('button', {
      staticClass: "btn btn-danger btn-sm",
      attrs: {
        "type": "button"
      },
      on: {
        "click": function($event) {
          _vm.remove(item.id)
        }
      }
    }, [_c('i', {
      staticClass: "far fa-trash-alt"
    })])])])
  })) : _vm._e(), _vm._v(" "), (_vm.draggable == false) ? _c('tbody', _vm._l((_vm.list), function(item) {
    return _c('tr', [_c('td', {
      attrs: {
        "data-label": _vm.title
      }
    }, [_vm._v(_vm._s(item[_vm.paramLabel] ? item[_vm.paramLabel] : item[_vm.paramName].nome))]), _vm._v(" "), _c('td', [_c('button', {
      staticClass: "btn btn-danger btn-sm",
      attrs: {
        "type": "button"
      },
      on: {
        "click": function($event) {
          _vm.remove(item.id)
        }
      }
    }, [_c('i', {
      staticClass: "far fa-trash-alt"
    })])])])
  })) : _vm._e()], 1)])])])], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-c6149276","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/DWSelectAdd.vue
// module id = 892
// module chunks = 1